export default __webpack_public_path__ + "static/media/5.ad7b0034.svg";